import {
  createSkuAvailabilityObject,
  createDefinedSkusObject,
  updateCollectionData,
  genderTMNT,
  getActiveProduct,
  getSelectedTilesForSku,
  formatFeatureFlags,
} from './ReducerHelpers';

const ProductPageReducer = (state, action) => {
  switch (action.type) {
    case 'INITIAL_QUERY_COMPLETE': {
      const collectionData = { ...action.payload.collection.collection };
      const tmntData = { ...action.payload.textFor };
      const {
        shippingContent,
        reviewData,
        content,
        featureFlags,
        config,
      } = { ...action.payload };

      let selectedTiles = {
        productId: getActiveProduct(collectionData, state.productId, state.sequence).productId,
      };

      if (state.type === 'edit' && state.sku) {
        selectedTiles = getSelectedTilesForSku(state.sku, collectionData.skus);
      }

      collectionData.definedSkus = collectionData.skus.reduce(createDefinedSkusObject, {});
      collectionData.skuAvailability = collectionData.skus.reduce(createSkuAvailabilityObject, {});
      collectionData.sizeChartType = collectionData.products[0].sizeChartType;
      collectionData.sizeChartSeq = collectionData.products[0].sizeChartSeq;
      collectionData.brand = collectionData.products[0].brand;
      collectionData.genderTMNT = genderTMNT(collectionData.gender, collectionData.brand, tmntData);
      const updatedCollectionData = updateCollectionData(collectionData, selectedTiles);
      const formattedFeatureFlags = formatFeatureFlags(featureFlags);

      return {
        ...state,
        collectionData: updatedCollectionData,
        tmntData,
        reviewData,
        shippingContent,
        content,
        featureFlags: formattedFeatureFlags,
        config,
      };
    }
    case 'UPDATE_ACTIVE_PRODUCT': {
      const collectionData = { ...state.collectionData };
      const selectedTiles = {
        ...collectionData.verifiedCriteria,
        productId: action.payload,
      };

      const updatedCollectionData = updateCollectionData(
        collectionData,
        selectedTiles,
      );

      return {
        ...state,
        productId: action.payload,
        collectionData: updatedCollectionData,
      };
    }
    case 'UPDATE_SELECTED_SIZE': {
      const { sizeType, value, isSticky } = action.payload;
      const collectionData = { ...state.collectionData };
      const selectedTiles = {
        ...collectionData.verifiedCriteria,
        primarySize: sizeType === 'primary' ? value : collectionData.verifiedCriteria?.primarySize,
        secondarySize: sizeType === 'secondary' ? value : collectionData.verifiedCriteria?.secondarySize,
      };

      const updatedCollectionData = updateCollectionData(
        collectionData,
        selectedTiles,
      );

      if (isSticky) {
        updatedCollectionData.stickySizeSelectionCompleted = updatedCollectionData.hasQualifiedSku;
      }

      return {
        ...state,
        collectionData: updatedCollectionData,
      };
    }
    case 'UPDATE_ACTIVE_PRODUCT_SOCIAL_PROOFING': {
      return {
        ...state,
        collectionData: {
          ...state.collectionData,
          hasSocialProofing: action.payload.hasSocialProofing,
        },
      };
    }
    default:
      return state;
  }
};

export default ProductPageReducer;
